import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WindowService, NgwWowService } from './services/index';

/**
 * Main module of the library
 */
@NgModule({
  imports: [
    CommonModule
  ]
})
export class NgwWowModule {
}
